
import { Component, Prop } from 'vue-property-decorator'
import { AppInput, AppInputQuill, AppSwitch } from '@/components'
import { integrationModuleEntity } from '@/models/models'
import { ChildComponentMixin } from '@/mixins'

type PriceType = 'PAID' | 'CONSULT' | 'FREE'

@Component({
    components: {
        AppInput,
        AppSwitch,
        AppInputQuill,
    },
})

export default class IntegrationFormApplicationData extends ChildComponentMixin {
    @Prop() public value?: IntegrationModuleEntity
    @Prop() public errors?: any

    get integrationModule(): IntegrationModuleEntity {
        return this.value ?? integrationModuleEntity
    }

    get priceOptions() {
        return [
            { value: 'PAID' , text: 'Paga' },
            { value: 'CONSULT' , text: 'A consultar' },
            { value: 'FREE' , text: 'Gratuita' },
        ]
    }

    get showPrice() {
        return this.integrationModule.priceType === 'PAID' && this.integrationModule.isDiscount
    }
}
